<p-toast position="bottom-right">
  <ng-template let-message pTemplate="message">
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      <div class="p-toast-detail" *ngIf="message.detail">{{ message.detail }}</div>
      <button *ngIf="toastReferenceCode(message)"
              pButton pRipple type="button" icon="fa-solid fa-clipboard"
              class="p-button-text p-button-sm copy-reference-code-button"
              [cdkCopyToClipboard]="toastReferenceCode(message)"
              (cdkCopyToClipboardCopied)="copiedToClipboard()"
              pTooltip="Copy reference code">
        Copy reference code
      </button>
    </div>
  </ng-template>
</p-toast>
<header class="site-header">
  <div class="left">
    <p-menubar [model]="menuBarItemsLeft">
      <ng-template pTemplate="start">

        <app-logo></app-logo>
        <!--        <ul class="inline-ul">-->
        <!--          <li class="logo">-->
        <!--        <span (click)="go(HeaderWithMenuComponent.Menu.TRADESORDERS)"-->
        <!--              class="logo-img out"></span>-->
        <!--            <div>-->
        <!--              <span class="name-img"></span>-->
        <!--              <span class="customer-name">{{customerName}}</span>-->
        <!--            </div>-->
        <!--          </li>-->
        <!--        </ul>-->
      </ng-template>
    </p-menubar>
  </div>
<!--  <div class="center">-->
<!--    &lt;!&ndash;    <ul class="inline-ul">&ndash;&gt;-->
<!--    &lt;!&ndash;      <li class="header-nav">&ndash;&gt;-->
<!--    &lt;!&ndash;        <div class="inline-ul">&ndash;&gt;-->
<!--    &lt;!&ndash;          <div [ngClass]="{'menu-item': true, 'active':true}">&ndash;&gt;-->
<!--    &lt;!&ndash;            <div class="content">&ndash;&gt;-->
<!--    &lt;!&ndash;              <div class="label uppercase">&ndash;&gt;-->
<!--    &lt;!&ndash;                &lt;!&ndash;                <span>{{menuItem | translate}}</span>&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;                <span>{{CrystalclearFrontUrl.label(this.router.url) | translate}}</span>&ndash;&gt;-->
<!--    &lt;!&ndash;              </div>&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;              <div *ngIf="active === menuItem"&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;                   class="select">&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;                <app-select-rounded&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;                  [placeholderEmpty]="'dashboard.no_dashboard' | translate"&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;                  [placeholder]="'dashboard.select_dashboard' | translate"&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;                  [selected]="null">&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;                </app-select-rounded>&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;                <app-select-rounded&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;                  [placeholderEmpty]="'checklist-dashboard.no_checklist' | translate"&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;                  [placeholder]="'checklist-dashboard.select_checklist' | translate"&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;                  [selected]="null">&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;                </app-select-rounded>&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;              &lt;!&ndash;              </div>&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;            </div>&ndash;&gt;-->
<!--    &lt;!&ndash;          </div>&ndash;&gt;-->
<!--    &lt;!&ndash;          &lt;!&ndash;          <p-menubar [model]="menuBarItems" >&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;          &lt;!&ndash;          </p-menubar>&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;          &lt;!&ndash;          <button #btn type="button" pButton icon="pi pi-fw pi-home" label="Show" (click)="menu.toggle($event)"></button>&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;          &lt;!&ndash;          <p-menu #menu [model]="menuItemsStatics" [popup]="true"></p-menu>&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;          &lt;!&ndash;          <button #btn type="button" pButton icon="pi pi-fw pi-list" label="Show" (click)="menu.toggle($event)"></button>&ndash;&gt;&ndash;&gt;-->
<!--    &lt;!&ndash;        </div>&ndash;&gt;-->
<!--    &lt;!&ndash;      </li>&ndash;&gt;-->
<!--    &lt;!&ndash;    </ul>&ndash;&gt;-->
<!--  </div>-->
  <div class="right">
    <p-menubar [model]="menuBarItemsRight">
    </p-menubar>
    <ul class="inline-ul">
      <li class="li-exit">
        <!--        <div (click)="abMenu.toggle($event)"-->
        <!--             class="menu-icon control-panel"-->
        <!--             pTooltip="{{'about_menu.about' | translate}}" tooltipPosition="bottom">-->
        <!--          <div class="icon about-icon"></div>-->
        <!--        </div>-->
        <!--        <p-menu #abMenu [popup]="true" [model]="aboutMenu" appendTo="body"></p-menu>-->

<!--        <button pButton pRipple (click)="toggleTheme();" type="button" class="p-button-info p-button-text theme-switch-button"-->
<!--        [icon]="'pi pi-'+(this.themeService.isDarkTheme?'moon':'sun')"></button>-->

<!--        <app-services-health></app-services-health>-->
        <button pButton pRipple (click)="helpDialogVisible=true" type="button"
                class="p-button-info p-button-text w-20px"
                icon="fa-solid fa-info"></button>
        <label class="switch" >
          <span (click)="toggleTheme();" class="slider round " [class]="this.themeService.isDarkTheme?'':'checked'">
            <i [class]="this.themeService.isDarkTheme?'fas fa-moon':'pi pi-sun'"></i></span>
<!--            <i class="fas fa-moon"></i><i class="pi pi-sun"></i></span>-->
        </label>
        <!--                [icon]="(this.themeService.isDarkTheme?'fa':'fas')+' fa-lightbulb'"></button>-->
        <div class="user">
          <span>
            <span *ngIf="!userInfo">
            </span>
            <span *ngIf="userInfo">
              <span *ngIf="userInfo.firstName && userInfo.lastName && userInfo.roles" class="user-info"
                    (click)="userFormVisible=true;">
                <i class="fas fa-user"></i>
                <span class="top-user-info">
                  <span>
                    {{userInfo.firstName}}
                  </span>
                  <span>
                    {{ userInfo.lastName}}
                  </span>
                </span>
                <!--              <hr class="separator-user-info">-->
                <!--              <span class="bot-user-info">-->
                <!--                {{ 'role.' + userInfo.roles.values().next().value.toString() | translate}}-->
                <!--              </span>-->
              </span>
              <span *ngIf="userInfo.username && !userInfo.firstName" class="user-info-username">
                {{userInfo.username}}
              </span>
            </span>
          </span>
        </div>

        <!--        <app-language></app-language>-->
        <app-notification *ngIf="appConfigService.notificationEnabled"></app-notification>
        <button pButton pRipple (click)="logInOut()" type="button" class="p-button-info p-button-text"
                icon="fa fa-sign-out-alt"></button>
        <!--        <div (click)="logInOut()" class="log-in-out-button"-->
        <!--             title="{{ (isAuthenticated ? 'header.log_out' : 'header.log_in') | translate }}">-->
        <!--          <div class="log-door"></div>-->
        <!--          <div class="log-arrow"></div>-->
        <!--        </div>-->
      </li>
    </ul>
  </div>
</header>


<app-user-form [formRecord]="userInfo"
                    [(dialogFormVisible)]="userFormVisible"
                    (onSave)="updateUser($event)"></app-user-form>
<app-help-dialog [(dialogFormVisible)]="helpDialogVisible"></app-help-dialog>
